export { default } from "./CookieBanner";
